import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fm110_01: string;
  fm110_11: string;
  fm110_80: string;
  fm110_21: boolean;
  fm110_20: boolean;
  fm110_90: number;
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const m5m1Api = {
  // POST /api/m5m1/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/m5m1/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/m5m1/execute
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/m5m1/execute', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
